import { render, staticRenderFns } from "./PersistCargaView.vue?vue&type=template&id=555f6b0c&"
import script from "./PersistCargaView.vue?vue&type=script&lang=ts&"
export * from "./PersistCargaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports